import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type Tone = "neutral" | "navy" | "accent" | "success" | "warning" | "danger";

const TONE: Record<Tone, string> = {
  neutral: "bg-neutral-100 text-neutral-700 border-neutral-200",
  navy: "bg-navy-50 text-navy-800 border-navy-100",
  accent: "bg-accent-100 text-accent-700 border-accent-300/40",
  success: "bg-success-100 text-success-700 border-success-700/20",
  warning: "bg-warning-100 text-warning-700 border-warning-700/20",
  danger: "bg-danger-100 text-danger-700 border-danger-700/20",
};

export function Badge({
  children,
  tone = "neutral",
  className,
  dotted,
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
  dotted?: boolean;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[11px] font-medium",
        TONE[tone],
        className,
      )}
    >
      {dotted && (
        <span
          className={cn(
            "inline-block w-1.5 h-1.5 rounded-full",
            tone === "success" && "bg-success-700",
            tone === "warning" && "bg-warning-700",
            tone === "danger" && "bg-danger-700",
            tone === "accent" && "bg-accent-600",
            tone === "navy" && "bg-navy-700",
            tone === "neutral" && "bg-neutral-500",
          )}
        />
      )}
      {children}
    </span>
  );
}
